/**
 * Админсикй сервис для работы с продуктами
 */
export default class ProductService {
	/**
	 * Инициализировать сервис
	 * @param {Object} httpClient
	 * @param {Object} errorHandler
	 */
	constructor(httpClient, errorHandler) {
		this.httpClient = httpClient
		this.errorHandler = errorHandler
	}

	/**
	 * Получить продукиы
	 */
	async getProducts() {
		try {
			return await this.httpClient.get("admin/producter/product")
		} catch (error) {
			throw this.errorHandler.handle(error).parse("Не удалось получить продукты")
		}
	}

	/**
	 * Привязать продукт к пользователю
	 * @param {Number} userId
	 * @param {Array} productIds
	 */
	async linkProduct(userId, productIds) {
		try {
			return await this.httpClient.post("admin/producter/product/user", {
				user_id: parseInt(userId),
				product_ids: productIds
			})
		} catch (error) {
			throw this.errorHandler.handle(error).parse("Не удалось привязать продукт к пользователю")
		}
	}

	/**
	 * Отвязать продукт от пользователя
	 * @param {Number} userId
	 * @param {Number} productId
	 */
	async unlinkProduct(userId, productId) {
		try {
			return await this.httpClient.delete("admin/producter/product/user", {
				user_id: parseInt(userId),
				product_id: parseInt(productId)
			})
		} catch (error) {
			throw this.errorHandler.handle(error).parse("Не удалось отвязать продукт от пользователя")
		}
	}
}
